import { Component, Inject,OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { LogsService } from 'src/app/service/document-control/logs.service';

@Component({
    selector: 'app-history-logs',
    templateUrl: './history-logs.component.html',
    styleUrls: ['./history-logs.component.scss'],
    standalone: false
})
export class HistoryLogsComponent implements OnInit {
  gridApi: any;
  icons;
  frameworkComponents;
  context: any;

  eventType: string;
  queueId: number;
  columnDefs = [];
  rowData = [];
  errormsg
  defaultColDef
  constructor(public dialogRef: MatDialogRef<HistoryLogsComponent>, @Inject(MAT_DIALOG_DATA) public dataStore: any, private readonly constants: Constants,
     private readonly ngxUiLoaderService: NgxUiLoaderService, private readonly  logsService: LogsService) {
    this.context = {
      componentParent: this
    };
    this.frameworkComponents = {};
    this.icons = {
      sortUnSort: '<img src="./assets/images/unsort.svg">',
    };
  }
  ngOnInit(): void {
    this.eventType = this.dataStore.eventType
    this.queueId = this.dataStore.queueId;
    this.defaultColDef = {
      suppressMovable: true, wrapText: true
    }
    this.columnDefs = [
      {
        headerName: "Timestamp", field: "timestamp",
        sortable: true, unSortIcon: true, autoHeight: true, width: 50, wrapText: true,
      },
      {
        headerName: "Message", field: "message", cellClass: "left_align", sortable: true, unSortIcon: true,
        autoHeight: true, wrapText: true,
      }
    ];
    this.getHistoryLogs(this.queueId)
  }


  getHistoryLogs(queueId) {
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)

    this.logsService.loadDataHistoryLogs(queueId).subscribe(
      response => {
        this.rowData = response
        this.gridApi?.setGridOption('rowData', this.rowData);
        this.gridApi?.resetRowHeights();
        // this.gridApi.onRowHeightChanged()
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
      }, _error => {
        this.errormsg = this.constants.APIErrorMessage
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
      }
    );
    this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
  }

  getRowHeight() {
    return 30;
  }

  sizeToFit() { this.gridApi?.sizeColumnsToFit(); }
  onGridReady(params) {
    this.gridApi = params.api
    this.gridApi.sizeColumnsToFit();
  }
  close(): void {
    this.dialogRef.close(
      { event: "CloseEvent" }
    );
  }
}
 
  